import { render, staticRenderFns } from "./hqglCanteenFee.vue?vue&type=template&id=0c2b39d8&scoped=true&"
import script from "./hqglCanteenFee.vue?vue&type=script&lang=js&"
export * from "./hqglCanteenFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b39d8",
  null
  
)

export default component.exports